export const environment = {
  production: true,
  baseURL: './../server',
  graphqlURL: './../server',
  accessTokenKey: 'ProdSbsChaserAccessToken',
  refreshTokenKey: 'ProdbsChaserRefreshToken',
  profileKey: 'ProdSbsChaserProfileKey',
  vapidPublicKey: 'BDXsZelvUEAqxVBlZKhLOqnQ0Nc1pTFMoUP_sGeV3cnkvEoqBi-Bqvf96YOyKd8ZotFQny-mNyDy2M05J-MQ7qc',
}
